export default {
  default: {
    size: 'md',
  },
  variants: {
    variant: {
      solid:
        'rounded-lg font-medium disabled:cursor-not-allowed aria-disabled:cursor-not-allowed disabled:opacity-75 aria-disabled:opacity-75 p-4 px-8 justify-center items-center cursor-pointer',
      outline: 'gap-2',
      link: 'px-0 py-0 md:px-0 md:py-0 md:p-0 p-0',
    },
    color: {
      white: 'bg-white text-(--ui-text-dark)',
      primary: 'text-white',
    },
    size: {
      md: {
        base: 'md:px-8 md:py-3.5 px-4 py-[13px]',
      },
      lg: {
        base: 'md:px-8 md:py-4.5 px-4 py-[13px]',
      },
      xl: {
        base: 'py-4.5',
      },
    },
  },
  compoundVariants: [
    {
      color: 'primary',
      variant: 'solid',
      class:
        'text-white bg-(--ui-primary) hover:bg-(--ui-primary)/75 disabled:bg-(--ui-primary) aria-disabled:bg-(--ui-primary) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--ui-primary)',
    },
    {
      color: 'green',
      variant: 'solid',
      class:
        'hover:bg-green active:bg-green hover:bg-green hover:brightness-107 active:brightness-95 cursor-pointer leading-none rounded-10px',
    },
  ],
};
